var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vuFormInput", class: _vm.classes, attrs: { id: _vm.p.id } },
    [
      _vm.hasLabel && !_vm.p.labelRight
        ? _c(
            "label",
            {
              staticClass: "vuFormInput__label",
              attrs: { id: _vm.p.id + "-label", for: _vm.p.id + "-input" },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "vuFormInput__wrap" }, [
        _c(
          "div",
          { staticClass: "vuFormInput__fieldWrap" },
          [
            _vm._t("beforeInput"),
            _vm._v(" "),
            _vm.p.type === "checkbox"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.p._value,
                          expression: "p._value",
                        },
                      ],
                      ref: "input",
                      staticClass: "vuFormInput__field",
                      style: _vm.fieldStyle,
                      attrs: {
                        id: _vm.p.id + "-input",
                        placeholder: _vm.p.placeholder,
                        required: _vm.p.required,
                        readonly: _vm.p.readOnly,
                        disabled: _vm.p.disabled,
                        "aria-labelledby":
                          !_vm.hasLabel || _vm.p._inputFieldAttr.ariaLabel
                            ? null
                            : _vm.p.id + "-label",
                        "aria-disabled": _vm.p.disabled ? "true" : null,
                        "aria-invalid": _vm.p._inputFieldAttr.ariaInvalid
                          ? _vm.p._inputFieldAttr.ariaInvalid
                          : _vm.p.isValid
                          ? null
                          : "true",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.p._value)
                          ? _vm._i(_vm.p._value, null) > -1
                          : _vm.p._value,
                      },
                      on: {
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        change: function ($event) {
                          var $$a = _vm.p._value,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(_vm.p, "_value", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.p,
                                  "_value",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.p, "_value", $$c)
                          }
                        },
                      },
                    },
                    "input",
                    _vm.p._inputFieldAttr,
                    false
                  )
                )
              : _vm.p.type === "radio"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.p._value,
                          expression: "p._value",
                        },
                      ],
                      ref: "input",
                      staticClass: "vuFormInput__field",
                      style: _vm.fieldStyle,
                      attrs: {
                        id: _vm.p.id + "-input",
                        placeholder: _vm.p.placeholder,
                        required: _vm.p.required,
                        readonly: _vm.p.readOnly,
                        disabled: _vm.p.disabled,
                        "aria-labelledby":
                          !_vm.hasLabel || _vm.p._inputFieldAttr.ariaLabel
                            ? null
                            : _vm.p.id + "-label",
                        "aria-disabled": _vm.p.disabled ? "true" : null,
                        "aria-invalid": _vm.p._inputFieldAttr.ariaInvalid
                          ? _vm.p._inputFieldAttr.ariaInvalid
                          : _vm.p.isValid
                          ? null
                          : "true",
                        type: "radio",
                      },
                      domProps: { checked: _vm._q(_vm.p._value, null) },
                      on: {
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        change: function ($event) {
                          return _vm.$set(_vm.p, "_value", null)
                        },
                      },
                    },
                    "input",
                    _vm.p._inputFieldAttr,
                    false
                  )
                )
              : _c(
                  "input",
                  _vm._b(
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.p._value,
                          expression: "p._value",
                        },
                      ],
                      ref: "input",
                      staticClass: "vuFormInput__field",
                      style: _vm.fieldStyle,
                      attrs: {
                        id: _vm.p.id + "-input",
                        placeholder: _vm.p.placeholder,
                        required: _vm.p.required,
                        readonly: _vm.p.readOnly,
                        disabled: _vm.p.disabled,
                        "aria-labelledby":
                          !_vm.hasLabel || _vm.p._inputFieldAttr.ariaLabel
                            ? null
                            : _vm.p.id + "-label",
                        "aria-disabled": _vm.p.disabled ? "true" : null,
                        "aria-invalid": _vm.p._inputFieldAttr.ariaInvalid
                          ? _vm.p._inputFieldAttr.ariaInvalid
                          : _vm.p.isValid
                          ? null
                          : "true",
                        type: _vm.p.type,
                      },
                      domProps: { value: _vm.p._value },
                      on: {
                        blur: _vm.onBlur,
                        focus: _vm.onFocus,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.p, "_value", $event.target.value)
                        },
                      },
                    },
                    "input",
                    _vm.p._inputFieldAttr,
                    false
                  )
                ),
            _vm._v(" "),
            _vm._t("addons"),
            _vm._v(" "),
            _vm.showVirtualPlaceholder
              ? _c(
                  "span",
                  {
                    ref: "virtualPlaceholder",
                    staticClass: "vuFormInput__virtualPlaceholder",
                  },
                  [_vm._v(_vm._s(_vm.p.placeholder))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("icon"),
            _vm._v(" "),
            _vm._t("beforeClearIcon"),
            _vm._v(" "),
            !_vm.p.noClear
              ? _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isEmpty,
                        expression: "!isEmpty",
                      },
                    ],
                    staticClass: "vuFormInput__clear",
                    attrs: {
                      href: "#",
                      tabindex: _vm.isEmpty ? -1 : null,
                      "aria-label": _vm.p.ariaClearLabel,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onClearClick.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._t("clearIcon", function () {
                      return [_vm._v("×")]
                    }),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("afterInput"),
          ],
          2
        ),
        _vm._v(" "),
        !_vm.p.isValid
          ? _c(
              "div",
              { staticClass: "vuFormInput__error" },
              [
                _vm._t(
                  "error",
                  function () {
                    return [_vm._v(_vm._s(_vm.p._error))]
                  },
                  { error: _vm.p._error }
                ),
              ],
              2
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.hasLabel && _vm.p.labelRight
        ? _c(
            "label",
            {
              staticClass: "vuFormInput__label vuFormInput__label--right",
              attrs: { id: _vm.p.id + "-label", for: _vm.p.id + "-input" },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }